import { getSeconds, addHours, getHours, getMinutes, formatDistance, parse, format, isValid } from "date-fns";
import * as datefnslocale from 'date-fns/locale'
import __t from "./traduzioni";

const SECONDS_TO_MILLISECONDS_COEFF = 1000;
const MINUTES_IN_HOUR = 60;

const commonFormats = {
    JS2JAVA: "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
    JAVA2JS: "yyyy-MM-dd HH:mm:ss",
    JSREADABLE: "dd/MM/yyyy HH:mm:ss",
    TIMESTAMP: "T",
    JSITA: "dd-MM-yyyy HH:mm:ss",
    SECONDSTIMESTAMP: "t",
}

const normalizeTime = (time) =>
    time.length === 1 ? `0${time}` : time;

const removeTimezoneDiff = secondsAmount => {
    const milliseconds = secondsAmount * SECONDS_TO_MILLISECONDS_COEFF;
    const date = new Date(milliseconds);
    const timezoneDiff = date.getTimezoneOffset() / MINUTES_IN_HOUR;
    const dateWithoutTimezoneDiff = addHours(date, timezoneDiff);

    return dateWithoutTimezoneDiff;
}

/**
 * Converte il numero di secondi in ore:minuti:secondi
 * 
 * @param {*} secondsAmount 
 * @returns 
 */
const convertToDuration = (secondsAmount) => {

    const dateWithoutTimezoneDiff = removeTimezoneDiff(secondsAmount)

    const hours = normalizeTime(String(getHours(dateWithoutTimezoneDiff)));
    const minutes = normalizeTime(String(getMinutes(dateWithoutTimezoneDiff)));
    const seconds = normalizeTime(String(getSeconds(dateWithoutTimezoneDiff)));

    //const hoursOutput = hours !== '00' ? `${hours}:` : '';

    return `${hours}:${minutes}:${seconds}`;
};

const humanDuration = (secondsAmount, sogliaOra = 60, sogliaMinuti = 5) => {
    const dateWithoutTimezoneDiff = removeTimezoneDiff(secondsAmount)

    let hours = getHours(dateWithoutTimezoneDiff);
    let minutes = getMinutes(dateWithoutTimezoneDiff)
    let minutesfromstart = (hours * 60) + minutes ;
    let seconds = getSeconds(dateWithoutTimezoneDiff);
    let secondsfromstart = (minutesfromstart * 60) + seconds;        

    let label = ``;
    

    if(minutesfromstart > sogliaOra){
        label = `${hours} ${ __t(hours === 1 ? "ora" : "ore")}`
    } else {
        if(minutesfromstart > sogliaMinuti){
            label = `${minutesfromstart} ${__t("minuti")}`
        } else {
            label = `${secondsfromstart} ${__t("secondi")}`
        }
    }

    return `${label}`;
}


const distanzaDataTesto = ({data, formato = commonFormats.JAVA2JS, opzioni = {locale: datefnslocale.it, addSuffix: true, includeSeconds: true}}) => {
    return formatDistance(parse(data, formato, new Date()), new Date(), opzioni)
}


export {convertToDuration, humanDuration, commonFormats, distanzaDataTesto}